export default "__VITE_ASSET__9135ee15__"